import { createContext } from "react";

export type PrivyXOAuthTokenContextValue = {
  reauthorizeX: () => Promise<void>;
  isSubmittingToken: boolean;
  lastTokenHandoffError: unknown;
};

export const PrivyXOAuthTokenContext =
  createContext<PrivyXOAuthTokenContextValue | null>(null);
